import { memo } from "react";
import { IconButton } from "@mui/material";
import { ChevronLeft, ChevronRight } from "@mui/icons-material";
import theme from "themeProvider";

const NavButton = ({ direction, onClick }) => (
  <IconButton
    onClick={onClick}
    size="small"
    aria-label={direction === "left" ? "Scroll left" : "Scroll right"}
    sx={{
      position: "absolute",
      top: "50%",
      [direction === "left" ? "left" : "right"]: 8,
      transform: "translateY(-50%)",
      zIndex: 2,
      background: theme.palette.common.white,
      border: `1px solid ${theme.palette.grey[300]}`,
      boxShadow: "0 1px 2px rgba(16, 24, 40, 0.06)",
      "&:hover": { background: theme.palette.grey[100] },
    }}
  >
    {direction === "left" ? <ChevronLeft /> : <ChevronRight />}
  </IconButton>
);

export default memo(NavButton);
